export default __webpack_public_path__ + "74cb2a985f3d21ca88f7682bfd452d83.png";